import React from "react";
import {Box} from "@mui/material";

export const AltroQuestion = () => {
  return(
      <Box>
          <></>
      </Box>
  )
}